import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import { useTheme } from '@mui/material/styles';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import tinyColor from 'tinycolor2';
import { useMobile } from 'src/hooks/useMobile';
import { useState } from 'react';
import { OptionalWrapper } from '../OptionalWrapper';
import Box from '@mui/system/Box';

export type FilterSaleTypeProps = {
  selectedSaleType: 'buy' | 'rent' | null;
  select: (saleType: 'buy' | 'rent' | null) => void;
};

export const FilterSaleType = ({ select, selectedSaleType }) => {
  const theme = useTheme();
  const isMobile = useMobile();

  const saleTypeButtons = [
    {
      text: 'buy now',
      variant: 'buy',
      onClick: () => {
        return select('buy');
      },
      color: 'success' as const,
    },
    {
      text: 'rent',
      variant: 'rent',
      onClick: () => {
        return select('rent');
      },
      color: 'royal' as const,
    },
    {
      text: 'all',
      variant: 'all',
      onClick: () => {
        return select(null);
      },
      color: 'info' as const,
    },
  ];
  const [saleTypeTitle, setSaleTypeTitle] = useState(saleTypeButtons[0].text);
  const handleChange = (event: SelectChangeEvent) => {
    setSaleTypeTitle(event.target.value);
  };
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        minWidth: isMobile ? undefined : 285,
        mx: 1,
      }}
    >
      <OptionalWrapper
        doWrap={isMobile}
        Wrapper={
          <Select
            renderValue={(p) => {
              return p;
            }}
            onChange={handleChange}
            value={saleTypeTitle}
            autoWidth={true}
            sx={{
              width: '114px',
              height: '42px',
              py: 0,
            }}
          />
        }
      >
        {saleTypeButtons
          .slice(!isMobile ? 0 : undefined, !isMobile ? 2 : undefined)
          .map(({ text, onClick, color, variant }) => {
            const isSelected = selectedSaleType === variant;
            return (
              <MenuItem
                key={text}
                value={text}
                sx={{
                  p: 0,
                  m: 0,
                  width: isMobile ? undefined : '100%',
                }}
              >
                <Button
                  disableElevation
                  value={text}
                  sx={{
                    width: isMobile ? '114px' : '100%',
                    height: '42px',
                    boxShadow: 'none',
                    borderRadius: '4px 4px 0px 0px',
                    borderColor: `${theme.palette[`${color}`].main}`,
                    borderBottom:
                      isSelected && !isMobile ? '2px solid' : 'none',
                    backgroundColor: isMobile
                      ? undefined
                      : isSelected
                      ? `${tinyColor(theme.palette[`${color}`].main).setAlpha(
                          0.15,
                        )}`
                      : `${tinyColor(theme.palette[`${color}`].main).setAlpha(
                          0.1,
                        )}`,
                    '&:hover': {
                      backgroundColor: isSelected
                        ? `${tinyColor(theme.palette[`${color}`].main).setAlpha(
                            0.175,
                          )}`
                        : `${tinyColor(theme.palette[`${color}`].main).setAlpha(
                            0.125,
                          )}`,
                    },
                  }}
                  key={text}
                  onClick={onClick}
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  color={color as any}
                >
                  <Typography sx={{ ...theme.lineClamp(1) }}>{text}</Typography>
                </Button>
              </MenuItem>
            );
          })}
      </OptionalWrapper>
    </Box>
  );
};
